import ListingStatusSelector from '@app/components/ListingStatusSelector'
import PropertyTypeSelector from '@app/components/PropertyTypeSelector'
import { PropertyType } from '@app/models/enums'
import { ApplicationState } from '@app/store'
import { IGlobalConfigurationState } from '@app/store/modules/global'
import { bindFunctions } from '@app/utils/class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { List } from 'immutable'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { RouteComponentProps } from 'react-router'
import { Button, ButtonGroup, Col, Input, Label, Row } from 'reactstrap'
import { actionCreators, IMapViewState } from '../modules/mapView'
import MapComponent from './Map'

type MapViewPageState = RouteComponentProps<{}> &
  IMapViewState &
  typeof actionCreators &
  ApplicationState &
  IGlobalConfigurationState

export default class MapViewPage extends React.PureComponent<MapViewPageState> {
  constructor(props: MapViewPageState) {
    super(props)

    bindFunctions(this)
  }

  public componentDidMount() {
    this.setState({ loaded: true })
    this._getProperties()
    this._getListings()
  }

  public render() {
    return this.props.isLoading ? (
      <div>Loading</div>
    ) : (
      <DocumentTitle title='MapView'>
        <div className='container h-100 pt-3'>
          <Row className='pl-3 align-items-center mb-2'>
            <h3 className='mb-0'>Property Map</h3>
            <ButtonGroup size='sm' className='mx-4'>
              <Button
                color={
                  this.props.markerOption === 'property'
                    ? 'primary'
                    : 'secondary'
                }
                title='Search Properties'
                onClick={() => this._onChangeMarkerOption('property')}
              >
                <FontAwesomeIcon icon={['fal', 'university']} fixedWidth />
              </Button>
              <Button
                color={
                  this.props.markerOption === 'listing'
                    ? 'primary'
                    : 'secondary'
                }
                title='Search Listings'
                onClick={() => this._onChangeMarkerOption('listing')}
              >
                <FontAwesomeIcon icon={['fal', 'list']} fixedWidth />
              </Button>
            </ButtonGroup>
          </Row>
          <Row>
            <Col md={8}>
              <Label>Search</Label>
              <Input id='input' type='text' bsSize='sm'></Input>
            </Col>
            <Col md={4}>
              {this.props.markerOption === 'property' && (
                <>
                  <Label>Property Type</Label>
                  <PropertyTypeSelector
                    value={this.props.propertyTypes}
                    onChange={this._onChangePropertyTypes}
                  />
                </>
              )}
              {this.props.markerOption === 'listing' && (
                <>
                  <Label>Listing Status</Label>
                  <ListingStatusSelector
                    value={this.props.listingStatus}
                    bsSize='sm'
                    onChange={this._onChangeListingStatus}
                  />
                </>
              )}
            </Col>
          </Row>
          <MapComponent
            filter={
              this.props.markerOption === 'property'
                ? this.props.propertyTypes
                : this.props.listingStatus
            }
            totalItems={this.props.totalItems}
            items={
              this.props.markerOption === 'property'
                ? this.props.properties
                : this.props.listings
            }
            isLoading={this.props.isLoading}
          />
        </div>
      </DocumentTitle>
    )
  }

  private _getProperties() {
    this.props.loadProperties()
  }

  private _getListings() {
    this.props.loadListings()
  }

  private _onChangePropertyTypes(value: List<PropertyType>) {
    this.props.setPropertyTypes(value)
  }

  private _onChangeMarkerOption(value: 'listing' | 'property') {
    this.props.setMarkerOption(value)
  }

  private _onChangeListingStatus(value: string) {
    this.props.SetListingStatus(value)
  }
}
